import VUE from 'vue';
import VUEX from 'vuex';
import nav from './modules/nav';

VUE.use(VUEX);

export default new VUEX.Store({
  modules: {
    nav, // namespaced: false,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js